import { useContext, useState } from "react";
import { useQueryClient } from "react-query";
import {
  useCreateExpenseDepartmentMutation,
  useUpdateExpenseDepartmentMutation,
} from "../../../../hooks/api/mutations/expenses";
import { cleanObject } from "../../../../helpers";
import { ToastContext } from "../../../../hooks/context";

export const useExpenseDepartmentForm = ({
  departmentDetails,
  isEditMode = false,
  closeModal = () => {},
}) => {
  const [formData, setFormData] = useState({
    name: departmentDetails?.name || "",
  });
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();

  const { mutate: createDepartment, isLoading: isCreatingDepartment } =
    useCreateExpenseDepartmentMutation();
  const { mutate: updateDepartment, isLoading: isUpdatingDepartment } =
    useUpdateExpenseDepartmentMutation();

  const handleAddExpenseDepartment = () => {
    if (!isEditMode)
      createDepartment(cleanObject({ ...formData }), {
        onSuccess: () => {
          triggerToast("Department created successfully", "success");
          closeModal();
        },
      });
    else
      updateDepartment(
        {
          data: cleanObject({ ...formData }),
          id: departmentDetails?.id,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries([
              "getExpenseDepartments",
              `${departmentDetails?.id}`,
            ]);
            triggerToast("Department Edited successfully", "success");
            closeModal();
          },
        },
      );
  };

  return {
    isCreatingDepartment: isUpdatingDepartment || isCreatingDepartment,
    formData,
    setFormData,
    handleAddExpenseDepartment,
  };
};
